// admin.import.tsx
// Route : /admin/import

import { createFileRoute } from "@tanstack/react-router";

import { useAuth } from "@/application/contexts/AuthContext";
import { AdminImportPage } from "@/presentation/pages/AdminImportPage";
import { UnauthorizedPage } from "@/presentation/pages/UnauthorizedPage";

export const Route = createFileRoute("/admin/import")({
  component: function AdminImportRoute() {
    const { isLoading, isSystemAdmin } = useAuth();

    if (isLoading) {
      return null;
    }

    if (!isSystemAdmin) {
      return <UnauthorizedPage />;
    }

    return <AdminImportPage />;
  },
});
